// src/pages/AddProperty/AddProperty.js
import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Business as BusinessIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import PropertyForm from '../../components/PropertyForm/PropertyForm';

const AddProperty = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Anunciar Imóvel
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Preencha as informações do seu imóvel para começar a receber interessados
        </Typography>
      </Box>

      {/* Banner XML para profissionais */}
      <Box
        sx={{
          mb: 3,
          p: 2,
          bgcolor: '#fff7f0',
          border: '1px solid #fde8d0',
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <BusinessIcon sx={{ color: '#F97316', fontSize: 22 }} />
          <Typography variant="body2" color="text.secondary">
            <strong style={{ color: '#1a1a1a' }}>Corretor ou imobiliária?</strong>{' '}
            Importe toda sua carteira de imóveis de uma só vez via XML.
          </Typography>
        </Box>
        <Button
          component={RouterLink}
          to="/minha-conta?tab=xml"
          size="small"
          endIcon={<ArrowForwardIcon />}
          sx={{
            color: '#F97316',
            fontWeight: 700,
            fontSize: '0.82rem',
            whiteSpace: 'nowrap',
            '&:hover': { bgcolor: '#fde8d0' }
          }}
        >
          Importar via XML
        </Button>
      </Box>

      <PropertyForm />
    </Container>
  );
};

export default AddProperty;
